import React, { useEffect, useState } from "react";
import * as Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import ColoumnsHeader from "../../generic/ColoumnsHeader";
import { convertRS, DropdownOptions } from "../../utlits";
import NoDataFound from "../../generic/NoDataFound";

export interface ILSPaiChartProps {
  orderTradeRatioData: any;
}

const LSPaiChart: React.FC<ILSPaiChartProps> = (props) => {
  const [dropdownValue, setDropdownValue] = useState<string>("NSE");
  const [ordTrdRatio, setOrdTrdRatio] = useState<any>({
    order: "",
    trade: "",
    ratio: "",
  });

  const [disableMenu, setDisableMenu] = useState<boolean>(false);

  useEffect(() => {
    if (
      props.orderTradeRatioData &&
      (props.orderTradeRatioData.ordsExcWise ||
        props.orderTradeRatioData.trdsExcWise ||
        props.orderTradeRatioData.ntOrdTrdRtoExchWiseCht)
    ) {
      setDisableMenu(false);
      let orderExchWise = props.orderTradeRatioData.ordsExcWise.filter(
        (order: any) => {
          return order.key === dropdownValue;
        }
      );
      let tradeExchWise = props.orderTradeRatioData.trdsExcWise.filter(
        (tarde: any) => {
          return tarde.key === dropdownValue;
        }
      );
      let ratioExchWise =
        props.orderTradeRatioData.ntOrdTrdRtoExchWiseCht.filter(
          (ordtrdRatio: any) => {
            return ordtrdRatio.key === dropdownValue;
          }
        );

      setOrdTrdRatio({
        order: parseInt(orderExchWise[0]?.val),
        trade: parseInt(tradeExchWise[0]?.val),
        ratio: parseInt(ratioExchWise[0]?.val),
      });
    } else {
      setDisableMenu(true);

      setOrdTrdRatio({
        order: 0,
        trade: 0,
        ratio: 0,
      });
    }
  }, [props.orderTradeRatioData, dropdownValue]);

  const options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
      height: "300px",
      reversedStacks: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      verticalAlign: "middle",
      horizontalAlign: "middle",
      floating: false,
      text: `${ordTrdRatio.ratio ? ordTrdRatio.ratio : 0}</br> Ratio`,
      y: 0,
      style: {
        color: "#707070",
        font: 'bold 20px "RobotoRegular", Verdana, sans-serif',
      },
    },
    legend: {
      symbolRadius: 2,
      itemMarginTop: 0,
      itemMarginBottom: -20,
    },
    colors: ["#1c9ad6", "#f7943e"],
    yAxis: {
      min: 0,
      title: "",
    },
    tooltip: {
      formatter: function (this: any): any {
        return `<b><p>${this.point.title}</p></br><span style="color:${
          this.point.color
        }">${this.point.name}</span> : ${convertRS(this.y, 2)}</b>`;
      },
      backgroundColor: "white",
      borderColor: "white",
      borderRadius: 10,
      borderWidth: 0,
      padding: 10,
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: false,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
          format: "<b>{point.name}</b>: {point.percentage:.1f} %",
        },
        showInLegend: true,
      },
    },
    series: [
      {
        innerSize: "90%",
        data: [
          {
            title: dropdownValue,
            name: "Orders",
            y: ordTrdRatio.order ? ordTrdRatio.order : 0,
          },
          {
            title: dropdownValue,
            name: "Trades",
            y: ordTrdRatio.trade ? ordTrdRatio.trade : 0,
          },
        ],
      },
    ],
  };
  return (
    <>
      <ColoumnsHeader
        // className="pointer"
        title={"Orders to Trades Ratio"}
        isDownload={false}
        dropdownOptions={DropdownOptions}
        setDropdownValue={setDropdownValue}
        isDropdown={true}
        disableMenu={disableMenu}
        dropdownValue={dropdownValue}
      />
      {disableMenu ? (
        <NoDataFound />
      ) : (
        <HighchartsReact highcharts={Highcharts} options={options} />
      )}
    </>
  );
};

export default LSPaiChart;
